import AWS from 'aws-sdk';
// import {useStateValue} from "./state";


export function getConnectionDetails(target) {
    // console.log('----> calling getConnectionDetails with: ' + target);

    const allConnections = [

        {
            "localhost:8000": {
                region: 'us-east-1',
                endpoint: 'http://localhost:8000',
                accessKeyId: 'fakeMyKeyId',
                secretAccessKey: 'fakeSecretAccessKey',
                IdentityPoolId: null,
                maxRetries: 5

            }
        },
        {
            CMH: {
                region: 'us-east-2',
                endpoint: 'http://dynamodb.us-east-2.amazonaws.com',
                accessKeyId: 'AKIAYSSU546KXT7KOP4F',
                secretAccessKey: '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',
                IdentityPoolId: null,
                maxRetries: 5
            }
        },
        {
            PDX: {
                region: 'us-west-2',
                endpoint: 'http://dynamodb.us-west-2.amazonaws.com',
                accessKeyId: 'AKIAJMM7I6LFFFFFFFFF',
                secretAccessKey: '3MPF019i8UFaRPbTX6ica2fy3h1ttttttttttttt',
                IdentityPoolId: null,
                maxRetries: 5
            }
        }
    ];

    if(target && target !== 'all') {
        return allConnections.filter(item => target === Object.keys(item)[0])[0];

    } else {
        return allConnections;
    }

}

export function createDynamoDbClient(client, target) {

    const fullConnection = getConnectionDetails(target);

    if(client && client === 'doc') {
        AWS.config.update(fullConnection[target]);

        return new AWS.DynamoDB.DocumentClient();

    } else {
        if (client === 'streams') {
            fullConnection[target].endpoint = fullConnection[target].endpoint.replace('dynamodb', 'streams.dynamodb');
            AWS.config.update(fullConnection[target]);

            return new AWS.DynamoDBStreams();

        } else {
            AWS.config.update(fullConnection[target]);
            return new AWS.DynamoDB();
        }
    }

}

